// Scripts for the basic banner component
import '../../../../styles/src/components/banners/basic.scss';
